import React, { useEffect } from 'react';
import PurchaseRegistration from 'src/Components/PurchaseRegistration';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { handleLogout } from '../Components/LogoutUtils';

import borgLogo from "../assets/img/Borg-logo.png";
import kepleraLogo from "../assets/img/Keplera-logo.png";
import Card from 'src/Components/Card';

const borgFeatures = (
  <div>
    <h3>Innovating Training and Readiness for Tomorrow’s Space Operators</h3>
    <ul>
      <li>Gaming Look & Feel</li>
      <li>Inertial & RIC Frames of Reference</li>
      <li>Build & modify orbits using Classical Orbital Elements</li>
      <li>Schedulable Satellite Maneuvers</li>
      <li>Ground & Space Sensors</li>
      <li>DA-ASAT & Orbital Launch Simulation</li>
      <li>Engagement Zones & Waypoints</li>
      <li>Ground-based Lasers & Jammers</li>
      <li>Rendezvous Proximity Ops</li>
      <li>40+ interactive Lessons covering an array of fundamental & advanced topics</li>
      <li>Immersive Competitive Scenarios with scoring, objectives, and leaderboards</li>
      <li>Sandbox Scenario Creation for analysis, event reconstruction, and/or wargaming</li>
      <li>Unified Data Library integration for Two Line Element Set data</li>
      <li>Data import and export</li>
    </ul>
  </div>
);

const kepleraFeatures = (
  <div>
    <h3>Educating the Next Generation on Astrodynamics Fundamentals!</h3>
    <ul>
      <li>Gaming Look & Feel</li>
      <li>Inertial & RIC Frames of Reference</li>
      <li>Build & modify orbits using Classical Orbital Elements</li>
      <li>Schedulable Satellite Maneuvers</li>
      <li>Ground & Space Sensors</li>
      <li>Orbital Launch Simulation</li>
      <li>Rendezvous Proximity Ops</li>
      <li>Interactive Lessons covering an array of fundamental & advanced topics</li>
      <li>Immersive Competitive Scenarios with scoring, objectives, and leaderboards</li>
      <li>Sandbox Scenario Creation for education and "what-if" scenarios</li>
      <li>Unified Data Library integration for Two Line Element Set data</li>
      <li>Data import and export</li>
    </ul>
  </div>
);

const colorAuriaYellow= "#FFBC46" //TODO - replace with a global value from style sheet

const isKepleraVersion = process.env.REACT_APP_PRODUCT_NAME === "keplera";

const productLogo = isKepleraVersion ? kepleraLogo : borgLogo;
const features = isKepleraVersion ? kepleraFeatures : borgFeatures;

type Props = {};

const RegisterPage = (props: Props) => {
  const pageType = useLocation().state as string || 'PurchaseSubscription'; //Pull in prop and use to conditionally render components or if no value found default to Purchase Subscription
  const navigate = useNavigate();

  // TODO: fix this input card to work with the register page columns
  return (
    <div>
      <div className="main-register"
        style={{
          display: 'flex',
          flexDirection: pageType === 'Standalone' ? 'column' : undefined,
        }}>
        <div className="borg-logo-purchase-info-container" style={{ display: 'flex', flexDirection: 'column' }}>
          <div className="borg-logo-mediumsize">
            <img alt="logo" src={productLogo} />
          </div>
          {/* Purchase Info not displayed if running Standalone Server */}
          {pageType !== 'Standalone' && (<div className="purchase-info">
            {pageType === 'PurchaseSubscription' && (<div>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2 }}>
                <Typography variant="h1" sx={{ color: colorAuriaYellow, fontSize: '5rem', mr: { xs: 1, md: 2 } }}>
                  $250
                </Typography>
                <Box>
                  <Typography variant="body1" sx={{ color: 'white' }}>
                    Billed Monthly
                  </Typography>
                  <Box sx={{ width: '100%', height: '2px', backgroundColor: colorAuriaYellow, mt: 1, mb: 1 }} />
                  <Typography variant="body1" sx={{ color: 'white' }}>
                    Cancel Anytime
                  </Typography>
                </Box>
              </Box>
            </div>)}
            {features}
          </div>)}
        </div>
        <PurchaseRegistration pageType={pageType} />
      </div>
    </div>
  );
};

export default RegisterPage;
